<template>
	<Teleport
		defer
		to="#main-content"
		v-if="autoFillModalOpen"
	>
		<InlineModal
			v-model:open="autoFillModalOpen"
			variant="small"
		>
			<template #header>
				<div class="mb-1 flex w-full items-center justify-end gap-3">
					<button
						type="button"
						@click="autoFillModalOpen = false"
					>
						<XMarkIcon class="text-secondary-300 h-6 w-6" />
					</button>
				</div>
			</template>
			<div class="flex flex-col items-center justify-center gap-4 text-center">
				<p class="text-secondary-900! font-bold">
					{{ t('document.resetFormHeader') }}
				</p>
				<p class="px-8 pb-4 text-sm font-extralight text-slate-500!">
					{{ t('document.resetFormMessage') }}
				</p>
				<button
					type="button"
					class="font-bold text-red-500! underline"
					@click="confirmResetForm"
				>
					{{ t('document.resetFormConfirm') }}
				</button>
				<button
					type="button"
					class="bg-accent-400! text-accent-700! hover:bg-accent-500! hover:text-accent-800! mb-2 w-full rounded-lg py-2 font-bold"
					@click="autoFillModalOpen = false"
				>
					{{ t('document.resetFormAbort') }}
				</button>
			</div>
		</InlineModal>
	</Teleport>
</template>

<script setup lang="ts">
import InlineModal from '@/components/common/InlineModal.vue'
import { usePresentationLocale } from '@/i18n'
import { useDocumentStore } from '@/stores/document'
import { useSessionDocumentsStore } from '@/stores/sessionDocuments'
import { XMarkIcon } from '@heroicons/vue/24/outline'
import { onMounted, onUnmounted, ref } from 'vue'

const documentStore = useDocumentStore()
const sessionDocumentsStore = useSessionDocumentsStore()
const { t } = usePresentationLocale()
const emit = defineEmits(['confirmResetForm'])

const autoFillModalOpen = ref(false)

onMounted(() => {
	document.addEventListener('foxit-autofill-button', async () => {
		autoFillModalOpen.value = true
	})
})

onUnmounted(() => {
	document.removeEventListener('foxit-autofill-button', async () => {
		autoFillModalOpen.value = true
	})
})

const confirmResetForm = async () => {
	emit('confirmResetForm')
	autoFillModalOpen.value = false
}
</script>

<style scoped></style>
